const code = 'backoffice';
const codeAPI = 'backoffice';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};